export default __webpack_public_path__ + "static/media/service.11ce31a2.png";